import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/modern-farmhouse-adu-popular.png";

const BlogModernFarmhouseADUs = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "Why Modern Farmhouse ADUs Are So Popular",
    "description": "Style + layout that actually makes sense. Learn why modern farmhouse ADUs are the most requested style in California.",
    "image": heroImage,
    "datePublished": "2026-04-03",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/modern-farmhouse-adus-popular" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />

      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="Why modern farmhouse ADUs are so popular" className="w-full rounded-2xl" />
      </div>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Blog
        </Link>

        <p className="text-sm text-muted-foreground mb-2">April 3, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
          Why Modern Farmhouse ADUs Are So Popular
        </h1>

        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>Modern farmhouse ADUs have become one of the most requested styles in California, and for good reason.</p>
          <p>They feel familiar. Clean white siding, black accents, simple rooflines. It works well in most neighborhoods without feeling out of place.</p>
          <p>But style alone is not what makes these units successful.</p>
          <p>The real value comes from the layout. Open living areas, functional kitchens, and efficient bedroom placement. Whether the ADU is used for rental income or family, the flow matters more than the exterior.</p>
          <p>We design every ADU with long-term use in mind. That means thinking about how someone will actually live in the space.</p>
          <p>A good ADU is not just built for today. It's built for flexibility.</p>
        </article>

        <BlogCTAButtons />
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogModernFarmhouseADUs;
